import styled from "styled-components";

// TODO get rid of these

export const Heading = styled.h2`
  font-size: var(--global-font-size-m);
  font-weight: var(--global-font-weight-regular);
`;

export const Subheading = styled.h3`
  font-weight: var(--global-font-weight-regular);
`;
